import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminCategories() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/categories").then((r) => setCategories(r.data || [])).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (name.trim().length < 2) return;
    try {
      await api.post("/admin/categories", { name: name.trim() });
      setName("");
      toast.success("Categoria criada.");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Não foi possível criar.");
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/categories/${id}`);
      toast.success("Categoria excluída.");
      load();
    } catch (err) {
      toast.error("Não foi possível excluir.");
    }
  };

  return (
    <div data-testid="admin-categories">
      <h1 className="font-display text-3xl text-navy">Categorias</h1>
      <p className="mt-2 text-sm text-inkgray">Categorias usadas para organizar os artigos do Conteúdo Jurídico.</p>

      <form onSubmit={add} className="mt-8 flex flex-col gap-3 sm:flex-row" data-testid="admin-category-form">
        <input
          className="w-full border border-navy/20 bg-white px-4 py-3 text-sm text-navy focus:border-gold sm:max-w-sm"
          placeholder="Nome da categoria (ex.: Direito Civil)"
          data-testid="admin-category-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button type="submit" className="inline-flex items-center justify-center gap-2 bg-navy px-6 py-3 text-[11px] font-bold uppercase tracking-[0.2em] text-ivory hover:bg-navy-2">
          <Plus size={14} /> Adicionar
        </button>
      </form>

      <div className="mt-8 space-y-3">
        {categories.length === 0 && <p className="border border-dashed border-navy/20 bg-white px-6 py-10 text-sm text-inkgray">Nenhuma categoria criada ainda.</p>}
        {categories.map((c) => (
          <div key={c.id} className="flex items-center justify-between border border-navy/10 bg-white px-5 py-4" data-testid={`admin-category-row-${c.slug}`}>
            <p className="text-sm font-semibold text-navy">{c.name}</p>
            <button data-testid={`admin-category-delete-${c.slug}`} onClick={() => remove(c.id)} className="border border-red-200 p-2 text-red-600 hover:bg-red-50" title="Excluir">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
